import BellSvg from '@assets/images/svg/bell.svg';
import React from 'react';
import { View } from 'react-native';

export function BellIcon({ size = 24, color = '#333333' }: { size?: number; color?: string }) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <BellSvg width={size} height={size} color={color} />
        </View>
    );
}


